import React from 'react';
import { Card, Button } from 'react-bootstrap';
import './Blog.css';

const blogPosts = [
  {
    title: 'Cómo Posicionar tu Negocio en Google Maps',
    imagePlaceholder: 'blog-image-1',
    excerpt: 'Descubre las claves para dominar los resultados locales y atraer más clientes a tu puerta.'
  },
  {
    title: 'El Poder del Video Marketing en 2025',
    imagePlaceholder: 'blog-image-2',
    excerpt: 'El contenido en video no es el futuro, es el presente. Aprende a usarlo para conectar y convertir.'
  },
  {
    title: 'Fotografía Profesional que Vende',
    imagePlaceholder: 'blog-image-3',
    excerpt: 'La primera impresión cuenta. Invierte en fotografía que muestre la calidad de tus productos y servicios.'
  }
];

const Blog = () => {
  return (
    <section id="blog" className="blog-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Recursos para Impulsar tu Marca</h2>
          <p className="lead text-muted">Nuestro conocimiento y experiencia a tu disposición.</p>
        </div>
        <div className="row">
          {blogPosts.map((post, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <Card className="h-100 blog-card">
                <div className={`card-img-top blog-image-placeholder ${post.imagePlaceholder}`}></div>
                <Card.Body className="d-flex flex-column">
                  <Card.Title as="h5" className="fw-bold">{post.title}</Card.Title>
                  <Card.Text className="text-muted small flex-grow-1">{post.excerpt}</Card.Text>
                  <Button variant="custom-orange" className="mt-auto align-self-start">Leer más</Button>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
        <div className="text-center mt-4">
          <Button variant="outline-secondary">Ver más artículos</Button>
        </div>
      </div>
    </section>
  );
};

export default Blog;
